export const buildTime = '2026-10-05 18:03:45 UTC';
